import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TagManager from 'react-gtm-module';

const GTMRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;

    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        page: pagePath,
      },
    });
  }, [location]);

  return null;
};

export default GTMRouteTracker;
